export default __webpack_public_path__ + "static/04-qs-latam-mobile-ed47620c1d436a18407fb5044beebf16.svg";